// ==============================================

//        NAV FUNCTIONS

// ==============================================

document.addEventListener('DOMContentLoaded', function (e) {


    //        Show more card projects
    // ==============================================
    
    let btnLoadMore   = document.getElementById('btn-load-more');

    // show more projects
    function loadMoreProjects(e) {
        e.preventDefault();

        this.classList.add('is-hidden');
        document.querySelectorAll('.card-project').forEach( function( el ) {
            if (el.classList.contains('is-hidden')) {
                el.classList.remove('is-hidden');
            }
        });
        
    }

    if (btnLoadMore) btnLoadMore.addEventListener('click', loadMoreProjects);

})
